import Cookies from 'js-cookie';

export default Cookies;
export * from '@/shared/constants/cookie';
